/* Panda Food 2.0, per-variant gallery.

   Shopify links exactly ONE image to a variant, so the buy box could only ever
   swap the main photo and slots 2-4 kept showing the previous colour. But the
   media is uploaded in runs: every variant's photos sit together, starting at
   the one image Shopify does link. Boxers run three or four images; socks run
   three images and a video, or two and two.

   Two things this has to get right, both checked against live data rather than
   assumed:

     1. variant.image.id is NOT product.media[].id. They are different id
        spaces and never match, on any product in this shop. The only reliable
        join is the image filename, which survives image_url transformation.

     2. variant.featured_image.position counts IMAGES only, while media.position
        counts images and videos together. On a product with videos the two
        drift apart, so position arithmetic silently hands a colour another
        colour's photos. Boxers have no videos, which is why position looked
        correct there. Filenames avoid the whole problem.

   Runs end at the next variant's start image, so a variant with two shots gets
   two, not two plus a borrowed one. */
(function () {
  var pdp = document.querySelector('[data-pf2-pdp]');
  if (!pdp) return;

  var stage = pdp.querySelector('[data-pf2-stage]');
  var thumbs = pdp.querySelector('[data-pf2-thumbs]');
  var idInput = pdp.querySelector('[data-pf2-variant-id]');
  var mapEl = pdp.querySelector('[data-pf2-variants]');
  var medEl = pdp.querySelector('[data-pf2-media]');
  if (!stage || !idInput || !mapEl || !medEl) return;

  var MAP = [], MEDIA = [];
  try {
    MAP = JSON.parse(mapEl.textContent) || [];
    MEDIA = JSON.parse(medEl.textContent) || [];
  } catch (e) { return; }
  if (!MEDIA.length) return;

  function fname(u) { return String(u || '').split('?')[0].split('/').pop(); }

  var at = {};
  MEDIA.forEach(function (m, i) {
    var f = fname(m.u);
    if (f && !(f in at)) at[f] = i;
  });

  var starts = {};
  MAP.forEach(function (v) { if (v.raw) starts[fname(v.raw)] = true; });

  function byId(id) {
    for (var i = 0; i < MAP.length; i++) {
      if (String(MAP[i].id) === String(id)) return MAP[i];
    }
    return null;
  }

  function runFor(v) {
    var i = at[fname(v.raw)];
    if (i === undefined) return v.img ? [{ t: 'i', u: v.img }] : [];
    var out = [];
    for (var j = i; j < MEDIA.length && out.length < 4; j++) {
      if (j > i && starts[fname(MEDIA[j].u)]) break;
      if (MEDIA[j].t === 'x') continue;
      out.push(MEDIA[j]);
    }
    /* a per-colour override replaces the linked photo but not the rest of the run */
    if (v.img && v.raw && v.img !== v.raw && out.length) out[0] = { t: 'i', u: v.img };
    return out;
  }

  var last = '';

  function paint() {
    var v = byId(idInput.value);
    if (!v) return;
    var shots = runFor(v);
    if (!shots.length) return;

    var key = shots.map(function (s) { return s.u; }).join('|');
    if (key === last) return;
    last = key;

    var h1 = pdp.querySelector('h1');
    var alt = (h1 ? h1.textContent.trim() : '').replace(/"/g, '&quot;');

    stage.innerHTML = shots.map(function (m, i) {
      var on = i === 0 ? ' show' : '';
      if (m.t === 'v') {
        /* preload none and no autoplay: the panel used to render as a black box
           while a 1080p file buffered. The poster carries the first frame. */
        return '<video class="pf2-v' + on + '" data-i="' + i + '" playsinline muted controls ' +
          'preload="none" poster="' + (m.p || '') + '"><source src="' + m.u + '" type="video/mp4"></video>';
      }
      return '<img class="' + (i === 0 ? 'show' : '') + '" data-i="' + i + '" src="' + m.u +
        '" alt="' + alt + '" width="1400" height="1400"' +
        (i === 0 ? ' loading="eager" fetchpriority="high"' : ' loading="lazy"') + '>';
    }).join('');

    if (thumbs) {
      /* a single shot needs no rail: one thumbnail reads as a broken row */
      thumbs.innerHTML = shots.length < 2 ? '' : shots.map(function (m, i) {
        var src = m.t === 'v' ? (m.p || '') : m.u;
        var label = m.t === 'v' ? 'Play video' : 'View image ' + (i + 1);
        return '<button type="button"' + (i === 0 ? ' class="active"' : '') +
          ' data-i="' + i + '" aria-label="' + label + '">' +
          '<img src="' + src + '" alt="" width="84" height="84" loading="eager" decoding="async">' +
          (m.t === 'v' ? '<span class="pf2-play" aria-hidden="true"></span>' : '') +
          '</button>';
      }).join('');
    }
  }

  /* delegated: the rail is rebuilt, so handlers bound to its buttons would die */
  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-i]');
      if (!btn) return;
      var i = btn.getAttribute('data-i');
      thumbs.querySelectorAll('button').forEach(function (b) { b.classList.toggle('active', b === btn); });
      stage.querySelectorAll('img,video').forEach(function (el) {
        var on = el.getAttribute('data-i') === i;
        el.classList.toggle('show', on);
        /* never leave audio playing behind a photo */
        if (!on && el.tagName === 'VIDEO' && !el.paused) el.pause();
      });
    });
  }

  function later() { setTimeout(paint, 0); }
  pdp.addEventListener('click', function (e) {
    if (e.target.closest('[data-pf2-opts] button')) later();
  });
  pdp.addEventListener('change', function (e) {
    if (e.target.closest('[data-pf2-opts]')) later();
  });

  paint();
})();
